/**
 * useCurrentUser hook
 * Fetches current user from Gateway and updates auth store
 */
import { useQuery } from '@tanstack/react-query'
import { authStore, authActions } from '@store/authStore'
import { gatewayClient } from '@infrastructure/api'
import { mapGatewayResponseToUser } from '@application/services'
import { AUTH_QUERY_KEYS } from './queryKeys'

export const useCurrentUser = () => {
  return useQuery({
    queryKey: AUTH_QUERY_KEYS.currentUser,
    queryFn: async () => {
      const rawResponse = await gatewayClient.getCurrentUser()
      if (!rawResponse) {
        throw new Error('Failed to fetch user')
      }

      const user = mapGatewayResponseToUser(rawResponse)
      if (!user) {
        throw new Error('Failed to map user response')
      }

      authActions.setUser(user)
      return user
    },
    enabled: authStore.isAuthenticated && authStore.isInitialized,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
  })
}
